import LoginSSO from './LoginSSO.jsx';

export default LoginSSO;



// WEBPACK FOOTER //
// ./src/components/modules/login-sso/index.js